//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Column, Row, TitleSection } from "components/styles";
import { Container, Content } from "../styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import HandlerRadio from "components/CustomRadio/CustomRadio";
import DialogAlert from "components/DialogAlert/DialogAlert";
//#endregion
//#region Services
import { requestReassignSchedule } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import { LOADING_MESSAGES } from "../../Popups/constants";
import { 
    getDateMonthString, getDatePartsByMillis, 
    getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import useMainContext from "utils/context/useMainContext";
//#endregion

const DialogScheduleReassignment = ({
    show, toggleShow,
    dateTimeData: { date, hour },
    reservation, schedules, 
    durationRender, setLoadingService, 
    reloadData
}) => {
    const mainContext = useMainContext();
    //#region States
    const [appointmentDateId, setAppointmentDateId] = useState(0);
    //#endregion
    //#region Functions
    const changeAppointmentDateId = (value) => {
        setAppointmentDateId(value);
    }
    const getReassignmentSuccessMessage = () => {
        const todayPrefix = date === -1 || getTodayWithoutHourInMillis() === date ? "Hoy " : "";
        const monthDate = getDatePartsByMillis(date).slice(1);
        const adviserName = schedules.find(({ appointmentDateId: currentAppointmentDateId }) => appointmentDateId === currentAppointmentDateId).adviser.name;
        return {
            message: `${todayPrefix}${getDateMonthString(monthDate, 1)}, ${reservation.studentName} ha sido reasignado con el asesor ${adviserName} con horario ${hour}:00 a ${hour+1}:00`,
            variant: "success",
            milis: 5000
        };
    }
    const reassignSchedule = async () => {
        toggleShow(false);
        const newLoadingService = {
            loading: true,
            message: LOADING_MESSAGES.UPDATE
        };
        setLoadingService({ ...newLoadingService });
        const success = await requestReassignSchedule({
            reservationId: reservation.id, 
            appointmentDateId
        });
        setLoadingService({ ...newLoadingService, loading: false });
        if (success) reloadData(getReassignmentSuccessMessage());
        else mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    return (
        <DialogAlert 
            show={show} 
            toggleShow={toggleShow}
            close={() => toggleShow(false)}>
            <Column 
                align="center" 
                marginTop="22px" marginBottom="22px">
                <TitleSection 
                    fontWeight="900" 
                    width="350px"
                    textAlign="center"
                    margin="15px 0">Asesores disponibles en este horario</TitleSection>
                <Row>{durationRender}</Row>
                <Container>
                    <Content>
                        <HandlerRadio
                            value={appointmentDateId}
                            onChange={changeAppointmentDateId}
                            radiosProps={schedules.map(({ 
                                appointmentDateId,
                                adviser: { name } 
                            }) => ({
                                value: appointmentDateId, 
                                label: name
                            }))} 
                            direction="column"
                            gap="25px"/>
                    </Content>
                </Container>
                <Row width="100%" justifyContent="center">
                    <CustomButton 
                        variant="secondary" 
                        size="medium" 
                        width="110px"
                        text="Cancelar"
                        onClick={() => toggleShow(false)}/>
                    <CustomButton 
                        size="medium" 
                        disabled={appointmentDateId === 0}
                        width="110px"
                        text="Aceptar"
                        onClick={reassignSchedule}/>
                </Row>
            </Column>
        </DialogAlert>
    );
}

export default DialogScheduleReassignment;